import {
  DndUploadEntry,
  DndUploadProgressState
} from "./dndUploadProgressTypes";

interface StateShape {
  ui: {
    dndUploadProgress: DndUploadProgressState;
  };
}

export const getDndUploadProgressState = (
  state: StateShape
): DndUploadProgressState => state.ui.dndUploadProgress || {};

export const getAllDndUploads = (state: StateShape): DndUploadEntry[] =>
  Object.values(getDndUploadProgressState(state));

/**
 * Returns uploads that should be shown in the toast right now.
 * Every active entry is visible as soon as it is dispatched — the toast
 * should render without delay so users see progress immediately.
 */
export const getVisibleDndUploads = (state: StateShape): DndUploadEntry[] => {
  return getAllDndUploads(state);
};

export interface DndUploadAggregate {
  totalFiles: number;
  completedFiles: number;
  erroredFiles: number;
  uploadingFiles: number;
  averageProgress: number;
  allComplete: boolean;
  hasError: boolean;
}

export const getDndUploadAggregate = (
  state: StateShape
): DndUploadAggregate => {
  const visible = getVisibleDndUploads(state);
  const totalFiles = visible.length;

  if (totalFiles === 0) {
    return {
      totalFiles: 0,
      completedFiles: 0,
      erroredFiles: 0,
      uploadingFiles: 0,
      averageProgress: 0,
      allComplete: false,
      hasError: false
    };
  }

  let completedFiles = 0;
  let erroredFiles = 0;
  let uploadingFiles = 0;
  let progressSum = 0;

  for (const entry of visible) {
    if (entry.status === "success") completedFiles += 1;
    else if (entry.status === "error") erroredFiles += 1;
    else uploadingFiles += 1;
    progressSum += entry.status === "success" ? 100 : entry.progress;
  }

  return {
    totalFiles,
    completedFiles,
    erroredFiles,
    uploadingFiles,
    averageProgress: Math.round(progressSum / totalFiles),
    allComplete: uploadingFiles === 0 && erroredFiles === 0,
    hasError: erroredFiles > 0
  };
};
